import { Component } from '@angular/core';

import { UserService, ROLE } from 'app/user/';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import { from } from 'rxjs/observable/from';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {

  public isAdmin: boolean = false;
  public isCoach: boolean = false;
  public isParticipant: boolean = false;


  constructor(
    private userService: UserService
  ) {
    this.userService.getUser()
    .then(user => {
      this.isAdmin = user.hasRole(ROLE.ADMIN)
      this.isCoach = user.hasRole(ROLE.COACH)
      this.isParticipant = user.hasRole(ROLE.PARTICIPANT)
    });
  }
}



// WEBPACK FOOTER //
// /dist/src/app/ui/sidebar/sidebar.component.ts